export default __webpack_public_path__ + "static/media/main-banner.bf853887.png";